export const FADE_ANIMATION_DURATION = 300;
export const MINIMUM_FILTER_INVENTORY = 8;
export const VIEW_ALL_COMPONENT = 'view_all';
export const TILE_SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
};
